/** @jsx jsx */
import React from 'react';
import { jsx } from '@emotion/core';
import { Order } from 'state/creditApplication';
import ExpandablePanel from 'components/ExpandablePanel';
import styles from './styles';
import useTranslate from 'hooks/useTranslate/useTranslate';
import { conformToMask, decimalMoneyMask } from 'utils/masks';

import { Divider } from '@material-ui/core';

export interface OrderSummaryProps {
  order: Order;
}

const OrderSummary: React.FC<OrderSummaryProps> = props => {
  const { order } = props;
  const t = useTranslate();

  return (
    <ExpandablePanel
      title={
        <span css={styles.panelText}>
          <img
            css={styles.panelIcon}
            src={`data:image/png;base64,${t(
              'unified.placeOrder.label.cartIcon',
            )}`}
            alt="Cart"
          />
          <p css={styles.panelTitle}>
            {t('unified.placeOrder.label.orderSummary')}
          </p>

          <p css={styles.panelSecondaryText}>
            {conformToMask(order.totalPriceValue.toFixed(2), decimalMoneyMask)}
          </p>
        </span>
      }
      panelName={'orderSummary'}
    >
      {order.items &&
        order.items.map(item => {
          return (
            <div css={styles.panelText} key={item.name}>
              <p
                css={styles.panelContentTitle}
              >{`${item.name} (Qty: ${item.quantity})`}</p>
              <p css={styles.panelSecondaryText}>
                {conformToMask(
                  item.unitPriceValue.toFixed(2),
                  decimalMoneyMask,
                )}
              </p>
            </div>
          );
        })}
      <div css={styles.panelText}>
        <p css={styles.panelContentTitle}>
          {t('unified.placeOrder.label.subTotal')}
        </p>
        <p css={styles.panelSecondaryText}>
          {conformToMask(order.subTotalValue.toFixed(2), decimalMoneyMask)}
        </p>
      </div>
      <Divider />
      <br />
      <div css={styles.panelText}>
        <p css={styles.panelContentTitle}>
          {t('unified.placeOrder.label.totalDiscount')}
        </p>

        <p css={styles.panelSecondaryText}>
          {conformToMask(
            order.totalDiscountsValue.toFixed(2),
            decimalMoneyMask,
          )}
        </p>
      </div>

      <div css={styles.panelText}>
        <p css={styles.panelContentTitle}>
          {t('unified.placeOrder.label.shipping')}
        </p>

        <p css={styles.panelSecondaryText}>
          {conformToMask(order.totalShippingValue.toFixed(2), decimalMoneyMask)}
        </p>
      </div>
      <div css={styles.panelText}>
        <p css={styles.panelContentTitle}>
          {t('unified.placeOrder.label.tax')}
        </p>
        <p css={styles.panelSecondaryText}>
          {conformToMask(order.totalTaxValue.toFixed(2), decimalMoneyMask)}
        </p>
      </div>
      <div css={styles.panelText}>
        <p css={styles.panelTotalTitle}>
          {t('unified.placeOrder.label.total')}
        </p>
        <p css={styles.panelTotalText}>
          {conformToMask(order.totalPriceValue.toFixed(2), decimalMoneyMask)}
        </p>
      </div>
    </ExpandablePanel>
  );
};

export default OrderSummary;
